import Minze, { EventListeners, MinzeAttrs, MinzeElement, Reactive } from 'minze'
import { Font } from '../../constants'
import { Time, getTimeFromString, getStringFromTime } from '../../modules/time'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'discoveryTime', {
  title: 'Quand êtes-vous disponible?',
  times: {
    today: "Aujourd'hui",
    thisWeek: 'Cette semaine',
    thisWeekend: 'Cette fin de semaine',
    nextWeek: 'La semaine prochaine',
    nextWeekend: 'Fin de semaine prochaine',
    thisMonth: 'Ce mois-ci',
    anytime: "N'importe quand",
  },
})

Locale.getInstance().registerKeySet('en', 'discoveryTime', {
  title: 'When are you available?',
  times: {
    today: 'Today',
    thisWeek: 'This week',
    thisWeekend: 'This weekend',
    nextWeek: 'Next week',
    nextWeekend: 'Next weekend',
    thisMonth: 'This month',
    anytime: 'Whenever',
  },
})

export class LvcDiscoveryTime extends MinzeElement {
  private _selectedTime: Time = Time.ANYTIME

  reactive: Reactive = [['selected', getStringFromTime(this._selectedTime), true]]

  async onReady(): Promise<void> {
    this._selected = encodeURIComponent(getStringFromTime(this._selectedTime))
  }

  async onTimeClick(event: any) {
    let target = event.target
    let chip = target.closest('lvc-chip')

    if (chip) {
      let value = chip.getAttribute('value')
      this._selectedTime = getTimeFromString(value)
      this.selected = encodeURIComponent(value)
      this.rerender()
    }
  }

  renderTimes = () => {
    let times: Time[] = [
      Time.TODAY,
      Time.THIS_WEEK,
      Time.THIS_WEEKEND,
      Time.NEXT_WEEK,
      Time.NEXT_WEEKEND,
      Time.THIS_MONTH,
      Time.ANYTIME,
    ]

    let html = ''

    for (let time of times) {
      html += `
        <lvc-chip
          x-responsive="true"
          theme="dark-borderless" 
          size="small"
          width="fit-content"
          value="${getStringFromTime(time)}" 
          class="category-chip" 
          ${time === this._selectedTime ? 'selected=true' : 'selected=false'}
          enable-hover-animation="true"
        >
          ${Locale.getKey(`discoveryTime.times.${getStringFromTime(time)}`)}
        </lvc-chip>
      `
    }

    return html
  }

  html = () => {
    return `
      <h1 class="title">${Locale.getKey('discoveryTime.title')}</h1>
      <lvc-box class="items-container" display="flex" flexDirection="column" alignItems="center" mb="40px">
        <lvc-charlie-ecoute-icon width="235" height="235"></lvc-charlie-ecoute-icon>
        <lvc-box display="flex" flexWrap="wrap" justifyContent="center" columnGap="8px" rowGap="8px">${this.renderTimes()}</lvc-box>
      </lvc-box>
    `
  }

  css = () => {
    return `
      :host {
        max-width: 540px;
        width: 100%;
        margin: 0 auto;
      }
      .title {
        text-align: center;
        font-size: 60px;
        font-weight: ${Font.weight.extraBold};
        line-height: 1;
        margin: 0 0 40px;
      }
      .items-container {
        position: relative;
      }
      lvc-charlie-ecoute-icon {
        position: absolute;
        right: 0;
        margin-right: -235px;
        top: 50%;
        margin-top: -117.5px;
      }
      @media screen and (max-width: 991px) {
        .title {
          font-size: 48px;
          margin-bottom: 0px;
        }
        lvc-charlie-ecoute-icon {
          margin: 0;
          position: static;
        }
        lvc-charlie-ecoute-icon::part(image) {
          width: 158px;
          height: 158px;
        }
      }
      @media screen and (max-width: 540px) {
        .title {
          font-size: 24px;
        }
      }
    `
  }

  eventListeners: EventListeners = [['lvc-chip', 'click', this.onTimeClick.bind(this)]]
}
